// extracted by mini-css-extract-plugin
export default {"root":"styles_root__+Gn8w","checked":"styles_checked__mGbUX","footer":"styles_footer__9mAUO","header":"styles_header__vgnML","link":"styles_link__5dG0A"};